var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5672 24.7354V22.9054C17.5672 21.9346 17.1576 21.0037 16.4285 20.3172C15.6995 19.6308 14.7106 19.2452 13.6796 19.2452H5.90434C4.87328 19.2452 3.88445 19.6308 3.15538 20.3172C2.42631 21.0037 2.01672 21.9346 2.01672 22.9054V24.7354",
    stroke: "currentColor",
    strokeWidth: 2.42217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79191 15.5849C11.939 15.5849 13.6795 13.9462 13.6795 11.9248C13.6795 9.90333 11.939 8.26462 9.79191 8.26462C7.64484 8.26462 5.9043 9.90333 5.9043 11.9248C5.9043 13.9462 7.64484 15.5849 9.79191 15.5849Z",
    stroke: "currentColor",
    strokeWidth: 2.42217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3469 10.7986H36.0167",
    stroke: "currentColor",
    strokeWidth: 2.42217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.347 17.1334H36.0169",
    stroke: "currentColor",
    strokeWidth: 2.42217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.347 23.4683H29.6819",
    stroke: "currentColor",
    strokeWidth: 2.42217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersAdmin);
export default __webpack_public_path__ + "static/media/usersAdmin.14655599d8bfc40c2fd36ea4762078f6.svg";
export { ForwardRef as ReactComponent };